import { Component, Input } from '@angular/core';
import { Student } from '../../../../models/student.model';

@Component({
    selector: 'app-student-detail-school',
    templateUrl: './student-detail-school.component.html',
    styleUrls: ['./student-detail-school.component.scss']
})
export class StudentDetailSchoolComponent {

    @Input() student: Student;

}
